import styled from "styled-components";

type SwitchProps = {
  switchWidth?: number;
  switchHeight?: number;
  startWithMinWidth?: boolean;
  switchColor?: string;
  switchHoverColor?: string;
};

export const CheckBoxWrapper = styled.div`
  position: relative;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  min-height: 20px;
  min-width: 36px;
  height: 20px;
  flex-shrink: 0;
  box-sizing: border-box;
`;

export const CheckBoxLabel = styled.label<SwitchProps>`
  position: absolute;
  top: 0;
  left: 0;
  width: 36px;
  height: 20px;
  border-radius: 15px;
  background: var(--light-gray);
  cursor: pointer;
  transition: background 0.3s ease;
  box-sizing: border-box;

  &::after {
    content: "";
    display: block;
    border-radius: 50%;
    width: 14px;
    height: 14px;
    margin: 3px;
    background: var(--white);
    transition: transform 0.3s ease;
    box-sizing: border-box;
  }
`;

export const CheckBox = styled.input<SwitchProps>`
  opacity: 0;
  z-index: 1;
  position: absolute;
  top: 0;
  left: 0;
  margin: 0;
  border-radius: 15px;
  width: 36px;
  height: 20px;
  cursor: pointer;
  box-sizing: border-box;
  
  &:checked + ${CheckBoxLabel} {
    background: var(--fixit);
    &::after {
      transform: translateX(16px);
    }
  }

  &:disabled {
    cursor: not-allowed;
  }

  &:disabled + ${CheckBoxLabel} {
    cursor: not-allowed;
    opacity: 0.6;
  }
`;
